import * as Sentry from "@sentry/react";
import { Routes, Route } from "react-router";
import { Layout } from "./components/layout/Layout";
import { LandingPage } from "./pages/landing/LandingPage";
import { LoginPage } from "./pages/auth/LoginPage";
import { RegisterPage } from "./pages/auth/RegisterPage";
import { AuthCallback } from "./pages/auth/AuthCallback";
import { MagicLinkCallback } from "./pages/auth/MagicLinkCallback";
import { ExplorePage } from "./pages/explore/ExplorePage";
import { ProfilePage } from "./pages/business/ProfilePage";
import { SettingsPage } from "./pages/dashboard/SettingsPage";
import { ServicesPage } from "./pages/dashboard/ServicesPage";
import { SchedulePage } from "./pages/dashboard/SchedulePage";
import { AccountPage } from "./pages/account/AccountPage";
import { BookingPage } from "./pages/booking/BookingPage";
import { BookingsPage } from "./pages/business/BookingsPage";
import { PostsPage } from "./pages/business/PostsPage";
import { UserBookingsPage } from "./pages/user/BookingsPage";
import { LookupPage } from "./pages/user/LookupPage";
import { PostDetailPage } from "./pages/post/PostDetailPage";
import { InboxPage } from "./pages/messages/InboxPage";
import { ConversationPage } from "./pages/messages/ConversationPage";
import { NotFoundPage } from "./pages/NotFoundPage";

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

export function App() {
  return (
    <SentryRoutes>
      <Route element={<Layout />}>
        <Route index element={<LandingPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="auth/callback" element={<AuthCallback />} />
        <Route path="auth/magic-link" element={<MagicLinkCallback />} />
        <Route path="explore" element={<ExplorePage />} />
        <Route path="b/:slug" element={<ProfilePage />} />
        <Route path="my-bookings" element={<UserBookingsPage />} />
        <Route path="bookings/lookup" element={<LookupPage />} />
        <Route path="book/:slug" element={<BookingPage />} />
        <Route path="messages" element={<InboxPage />} />
        <Route path="messages/:id" element={<ConversationPage />} />
        <Route path="posts/:id" element={<PostDetailPage />} />
        <Route path="dashboard/bookings" element={<BookingsPage />} />
        <Route path="dashboard/posts" element={<PostsPage />} />
        <Route path="dashboard/settings" element={<SettingsPage />} />
        <Route path="dashboard/services" element={<ServicesPage />} />
        <Route path="dashboard/schedule" element={<SchedulePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </SentryRoutes>
  );
}
